<template>

	<div class="relative flex flex-col justify-between min-h-screen font-body">
		<Header />

		<main class="h-full">
			<Transition>
				<Hello v-if="$store.state.helloView" />
			</Transition>

			<Transition>
				<Confirm v-if="$store.state.confirmView" />
			</Transition>

			<Transition>
				<Quiz v-if="$store.state.quizView && !$store.state.resultView && !$store.state.confirmView" />
			</Transition>

			<Transition>
				<Results :snofy="$store.state.youAre" v-show="$store.state.resultView" />
			</Transition>
		</main>

		<Footer />
	</div>

</template>

<script>
import Header from './layout/Header.vue';
import Footer from './layout/Footer.vue';
import Hello from './layout/Hello.vue';
import Confirm from './layout/Confirm.vue';
import Quiz from './layout/Quiz.vue';
import Results from './layout/Results.vue';

export default {
	name: 'App',
	components: {
		Header,
		Footer,
		Hello,
		Confirm,
		Quiz,
		Results
	},
}
</script>

<style>
.v-enter-active,
.v-leave-active {
	transition: transform 0.5s ease;
}

.v-enter-from,
.v-leave-to {
	transform: translateY(-100%);
}

.view {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
	overflow-y: scroll;

	@media (max-width: 600px) {
		box-shadow: none;
	}
}
</style>